import {addDays, startOfDay} from 'date-fns';

import {parseDate} from 'shared/web';

type TestDriveCalendarWindow = {
  from: string;
  to: string;
};

export const getTestDriveCalendarWindow = (
  selectedDate: string,
  rangeDays: number
): TestDriveCalendarWindow => {
  const from = startOfDay(parseDate(selectedDate));

  return {
    from: from.toISOString(),
    to: startOfDay(addDays(from, rangeDays)).toISOString(),
  };
};
